// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumbStyle_breadcrumbs__E77rE {
  margin: 0;
}
.breadcrumbStyle_breadcrumbs__E77rE a,
.breadcrumbStyle_breadcrumbs__E77rE p,
.breadcrumbStyle_breadcrumbs__E77rE h5,
.breadcrumbStyle_breadcrumbs__E77rE h6 {
  font: var(--body-font-three);
  color: var(--brand);
  letter-spacing: 0.3px;
  text-transform: capitalize;
  text-decoration: none;
}
.breadcrumbStyle_breadcrumbs__E77rE a:hover,
.breadcrumbStyle_breadcrumbs__E77rE p:hover,
.breadcrumbStyle_breadcrumbs__E77rE h5:hover,
.breadcrumbStyle_breadcrumbs__E77rE h6:hover {
  color: #0a537b;
}
.breadcrumbStyle_breadcrumbs__E77rE li {
  margin: 0;
  color: var(--brand) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/breadcrumb/breadcrumbStyle.module.scss"],"names":[],"mappings":"AAAA;EACC,SAAA;AACD;AACC;;;;EAIC,4BAAA;EACA,mBAAA;EACA,qBAAA;EACA,0BAAA;EACA,qBAAA;AACF;AACE;;;;EACC,cAAA;AAIH;AAAC;EACC,SAAA;EACA,8BAAA;AAEF","sourcesContent":[".breadcrumbs {\r\n\tmargin: 0;\r\n\r\n\ta,\r\n\tp,\r\n\th5,\r\n\th6 {\r\n\t\tfont: var(--body-font-three);\r\n\t\tcolor: var(--brand);\r\n\t\tletter-spacing: 0.3px;\r\n\t\ttext-transform: capitalize;\r\n\t\ttext-decoration: none;\r\n\r\n\t\t&:hover {\r\n\t\t\tcolor: #0a537b;\r\n\t\t}\r\n\t}\r\n\r\n\tli {\r\n\t\tmargin: 0;\r\n\t\tcolor: var(--brand) !important;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumbs": `breadcrumbStyle_breadcrumbs__E77rE`
};
export default ___CSS_LOADER_EXPORT___;
